//need to match index.css
export const Colors = {
  lightGreen: '#70d44b',
  mediumGreen: '#009d4f',
  darkGreen: '#007960',
  lightGray: '#eeeeee',
  white: '#ffffff',
};
